type PlainObject = Record<string, unknown>;

export function toCamelCase<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item)) as T;
  }

  if (obj !== null && typeof obj === 'object') {
    const RESULT: PlainObject = {};

    for (const [KEY, VAL] of Object.entries(obj)) {
      const CAMLE_KEY = KEY.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
      RESULT[CAMLE_KEY] = VAL !== null && typeof VAL === 'object' ? toCamelCase(VAL) : VAL;
    }

    return RESULT as T;
  }

  return obj;
}
